import QueryString from "qs"
import http from "../index"
import {
  apiDropdownCountry,
  apiDropdownNetwork,
  apiListPackageSell,
  apiListSimSell,
  apiShareSim,
} from "./urls"

const getListSimSell = params => http.get(apiListSimSell, { params })
const getListPackageSell = params => http.get(apiListPackageSell, { params })
const getDropdownCountry = params => http.get(apiDropdownCountry, { params })
const getDropdownNetwork = params => http.get(apiDropdownNetwork, { params })

const PublicService = {
  getListSimSell,
  getListPackageSell,
  getDropdownCountry,
  getDropdownNetwork,
}
export default PublicService
